import React from "react"
import { StaticQuery, graphql } from "gatsby"
import ServiceCard from "./service-card"

const PostMaker = ({ data }) => (
  <section className="home-posts">
    <h2>Services</h2>
    <div className="grids col-1 sm-2 lg-3">
      {data}
    </div>
  </section>
)

export default function ServiceListHome() {
  return (
    <StaticQuery 
      query={graphql`
        query {
          allMarkdownRemark(
            sort: { order: DESC, fields: [frontmatter___date] }
            filter: { frontmatter: { template: { eq: "service" } } }
            limit: 6
          ) {
            edges {
              node {
                id
                excerpt(pruneLength: 250)
                frontmatter {
                  date(formatString: "MMMM DD, YYYY")
                  slug
                  title
                  featuredImage {
                    childImageSharp {
                      fluid(maxWidth: 540, maxHeight: 360, quality: 80) {
                        ...GatsbyImageSharpFluid
                        ...GatsbyImageSharpFluidLimitPresentationSize
                      }
                      fixed(width:400) {
                        ...GatsbyImageSharpFixed
                      }
                    }
                  }
                }
              }
            }
          }
        }`
      }

      render={ data => {
          const services = data.allMarkdownRemark.edges
            .filter(edge => !!edge.node.frontmatter.date)
            .map(edge =>
              <ServiceCard key={edge.node.id} data={edge.node} />
          )
          return <PostMaker data={services} />
        } 
      }
    />
  )
}